// GET /api/cases?status=open&caseStage=filing - the filings queue: open
// matters in the filing stage, "open" being the server's own word (the one
// the cases list and /api/firm/counts use). Deliberately no fixture
// fallback: prototype matters carry no real case stage, so the page owns
// honest empty and error screens instead (the /clients pattern).

import { getAuthHeaders } from "./auth";
import { adaptCaseToMatter, type ServerCaseShape } from "./mock";
import type { Matter } from "../data/types";

export interface FilingsQueueResult {
  matters: Matter[];
  total: number;
}

// The server's listQuerySchema caps limit at 100.
const FILINGS_PAGE = 100;

export async function fetchFilingsQueue(): Promise<FilingsQueueResult> {
  const res = await fetch(`/api/cases?status=open&caseStage=filing&limit=${FILINGS_PAGE}`, {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`GET /api/cases?status=open&caseStage=filing failed: ${res.status}`);
  const json = (await res.json()) as { cases?: ServerCaseShape[]; total?: number };
  const cases = json.cases ?? [];
  return { matters: cases.map(adaptCaseToMatter), total: json.total ?? cases.length };
}
